<div class="games-slider">
    <div class="games-slider__body js-games-slider">
        <button class="games-slider__slide"
                (click)="selectGame(game.short_name)"
                 *ngFor="let game of getGames()">
                <img [src]="'../../../assets/images/games-playground/' + getProviderSlideImg(game.short_name)" alt="">
        </button>
    </div>
</div>
